import React, { useState } from 'react';
import Navbar from '../Components/NavBarV2';
import MapShow from '../Components/mapShow';
import Footer from '../Components/footer';
import '../Pages/mapPlaces.css';

const MapPlaces = () => {
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [selectedSpace, setSelectedSpace] = useState(null);

    const handleSelectPlace = (place) => {
        setSelectedPlace(place);
    };

    const handleSelectSpace = (space) => {
        setSelectedSpace(space);
    };

    return (
        <div>
            <Navbar />
            <div className="map-places">
            <MapShow onSelectPlace={handleSelectPlace} onSelectSpace={handleSelectSpace} />
            </div>
        </div>
    );
};

export default MapPlaces;
